import React, { useEffect, useState } from 'react'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core'
import { AccessAlarm, CheckCircleOutlineOutlined, HighlightOff, StarsRounded } from '@material-ui/icons'
import { dinamicTablesStyles } from './styles'

const ActionsTable = ({ info }) => {
  const [filteredArray, setFilteredArray] = useState(info)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [selectedBtn, setSelectedBtn] = useState('todas')
  const [count, setCount] = useState(info)
  const classes = dinamicTablesStyles()
  const filterActions = (initialArray, key) => {
    const newArray = initialArray.filter(el => el[key] > 0)
    setFilteredArray(newArray)
    setCount(newArray)
    setPage(0)
    if (key === 'todas') {
      setFilteredArray(info)
      setCount(info)
      setPage(0)
    }
    setSelectedBtn(key)
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    setFilteredArray(info)
    setCount(info)
  }, [info])
  return (
    <Box className={classes.container}>
      <h3 className={classes.title}>Acciones de mejora</h3>
      <Box>
        <Button
          className={selectedBtn === 'todas' ? classes.btnSelected : classes.btnFilter}
          onClick={() => filterActions(info, 'todas')}
        >
          Todas las acciones
        </Button>
        <Button
          className={selectedBtn === 'total' ? classes.btnSelected : classes.btnFilter}
          onClick={() => filterActions(info, 'total')}
          startIcon={<StarsRounded style={{ color: '#F5CD26' }} />}
        >
          Total
        </Button>
        <Button
          className={selectedBtn === 'completas' ? classes.btnSelected : classes.btnFilter}
          onClick={() => filterActions(info, 'completas')}
          startIcon={<CheckCircleOutlineOutlined style={{ color: '#65BA0F' }} />}
        >
          Completas
        </Button>
        <Button
          className={selectedBtn === 'pendientes' ? classes.btnSelected : classes.btnFilter}
          onClick={() => filterActions(info, 'pendientes')}
          startIcon={<AccessAlarm style={{ color: '#2699FB' }} />}
        >
          Pendientes
        </Button>
        <Button
          className={selectedBtn === 'vencidas' ? classes.btnSelected : classes.btnFilter}
          onClick={() => filterActions(info, 'vencidas')}
          startIcon={<HighlightOff style={{ color: '#BA330F' }} />}
        >
          Vencidas
        </Button>
      </Box>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell>Socio</TableCell>
              <TableCell>Total acciones</TableCell>
              <TableCell>Acciones completas</TableCell>
              <TableCell>Acciones pendientes</TableCell>
              <TableCell>Acciones vencidas</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {filteredArray?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
              <TableRow key={item.socio}>
                <TableCell style={{color: '#2699FB'}}>{item.socio}</TableCell>
                <TableCell className={classes.centeredCell}>{item.total}</TableCell>
                <TableCell className={classes.centeredCell}>{item.completas}</TableCell>
                <TableCell className={classes.centeredCell}>{item.pendientes}</TableCell>
                <TableCell className={classes.centeredCell}>{item.vencidas}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default ActionsTable